// export const { useDetail, usePaged, useUpdate, useCount, useInfiniteLoad } =
//   generateHooks<IAsset, number, ICreateAsset, IUpdateAsset>(GENERATOR_PARAMS);
export var _ = function () { };
